<template lang="pug">
.schools-submenu
    ul
        li
            h4 Filters
        li 
            router-link(:to="{ query: { ...$route.query, state: null } }") All schools
            el-badge.school_badge(v-if="totals.all" :value="totals.all" type="info")
        li 
            router-link(:to="{ query: { ...$route.query, state: 'offline' } }") Offline schools
            el-badge.school_badge(v-if="totals.offline" :value="totals.offline" type="info")
        li 
            router-link(:to="{ query: { ...$route.query, state: 'pending' } }") Pending schools
            el-badge.school_badge(v-if="totals.pending" :value="totals.pending" type="info")
        li 
            router-link(:to="{ query: { ...$route.query, state: 'approved' } }") Approved schools
            el-badge.school_badge(v-if="totals.approved" :value="totals.approved" type="info")
        li 
            router-link(:to="{ query: { ...$route.query, state: 'awaitingAudit' } }") Awaiting audit schools
            el-badge.school_badge(v-if="totals.awaitingAudit" :value="totals.awaitingAudit" type="info")
        li
            router-link(:to="{ query: { ...$route.query, state: 'audited' } }") Audited schools
            el-badge.school_badge(v-if="totals.audited" :value="totals.audited" type="info")
        li 
            router-link(:to="{ query: { ...$route.query, state: 'declined' } }") Declined schools
            el-badge.school_badge(v-if="totals.declined" :value="totals.declined" type="info")
    regions-partial
    mis-partial
</template>

<script>
import RegionsPartial from "./RegionsPartial";
import MisPartial from "./MisPartial";
import gql from "graphql-tag";

export default {
	components: {
		MisPartial,
		RegionsPartial
	},
	computed: {
		totals() {
			if (!this.AssociatedSchools) return {};

			return {
				all: this.AssociatedSchools.length,
				offline: this.AssociatedSchools.filter(s => s.online == false && s.demo == false).length,
				pending: this.AssociatedSchools.filter(s => !s.approved && !s.declined).length,
				approved: this.AssociatedSchools.filter(s => s.approved).length,
				awaitingAudit: this.AssociatedSchools.filter(s => s.audit_approval == null && s.approved).length,
				audited: this.AssociatedSchools.filter(s => s.audit_approval != null && s.approved).length,
				declined: this.AssociatedSchools.filter(s => s.declined && !s.approved).length
			};
		}
	},
	apollo: {
		AssociatedSchools: {
			query: gql`
				query AssociatedSchools($state: String) {
					AssociatedSchools(state: $state) {
						id
						approved
						declined
						online
						demo
						audit_approval
					}
				}
			`,
			fetchPolicy: "cache-and-network"
		}
	}
};
</script>
<style lang="css" scoped>
.school_badge {
    float: right;
    margin-top: 5px;
}
    .school_badge >>> .el-badge__content {
        font-size: 0.6em !important;
    }
.schools-submenu ul li a {
    font-size: 0.85em;
}
</style>
